/*
 * サイズ未選択のままカートに入れられないようにする
 *
 * ① 未選択のあいだは「カートに追加する」を disabled にし、
 *    文言を「サイズを選択してください」に差し替える。
 *    disabled の見た目は売り切れと同じ灰色（assets/iroiro-product.css）。
 *
 * ② 保険として送信時にも止める。
 *    snippets/iroiro-size-selector.liquid の select は required だが、
 *    Dawn の商品フォームは novalidate 付きで出力されるため
 *    （snippets/buy-buttons.liquid の {% form 'product', novalidate: 'novalidate' %}）、
 *    ブラウザ標準の検証は動かない。
 *    Dawn 本体を編集せずに止めるため、submit を document のキャプチャ段階で受ける。
 *    キャプチャはフォーム自身のリスナー（Dawn の product-form.js）より先に走るので、
 *    ここで stopPropagation すれば Dawn の送信処理には届かない。
 */
(function () {
  'use strict';

  var FORM = 'form[data-type="add-to-cart-form"]';
  var NAME = 'properties[size]';
  var SELECT = 'select[name="' + NAME + '"]';
  /* 元の文言の置き場。この属性の有無が「こちらが止めている」印にもなる */
  var LOCK = 'data-iroiro-size-lock';

  function selectIn(form) {
    /*
     * select はフォームの外にあり form 属性で紐付いている。
     * form.elements はその紐付けを見てくれるので、DOMを辿らずに取れる。
     */
    var field = form.elements[NAME];
    return field && field.tagName === 'SELECT' ? field : null;
  }

  function errorFor(select) {
    var id = select.getAttribute('aria-describedby');
    return id ? document.getElementById(id) : null;
  }

  function setInvalid(select, invalid) {
    var message = errorFor(select);
    select.setAttribute('aria-invalid', invalid ? 'true' : 'false');
    select.classList.toggle('is-invalid', invalid);
    if (message) message.hidden = !invalid;
  }

  /* ボタンの文言。Dawn は <span>文言</span> + 読み込み中のスピナー という構成 */
  function labelOf(button) {
    return button.querySelector('span:not([class])') || button.querySelector('span');
  }

  function chooseText(select) {
    var box = select.closest('.iroiro-size');
    return (box && box.dataset.iroiroSizeChoose) || 'サイズを選択してください';
  }

  function sync(select) {
    var form = select.form;
    var button = form && form.querySelector('button[name="add"]');
    if (!button) return;

    var label = labelOf(button);
    if (!label) return;

    var locked = button.hasAttribute(LOCK);

    if (!select.value) {
      if (locked) return;
      /*
       * 売り切れなど Dawn が別の理由で止めているときは触らない。
       * 「売り切れ」の表示を「サイズを選択してください」で上書きしてしまわないため。
       */
      if (button.hasAttribute('disabled')) return;

      button.setAttribute(LOCK, label.textContent);
      button.setAttribute('disabled', 'disabled');
      label.textContent = chooseText(select);
      return;
    }

    if (locked) {
      label.textContent = button.getAttribute(LOCK);
      button.removeAttribute(LOCK);
      button.removeAttribute('disabled');
    }
  }

  function syncAll() {
    Array.prototype.forEach.call(document.querySelectorAll(SELECT), sync);
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form.matches || !form.matches(FORM)) return;

      var select = selectIn(form);
      if (!select) return;

      if (select.value) {
        setInvalid(select, false);
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      setInvalid(select, true);
    },
    true
  );

  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.matches || !select.matches(SELECT)) return;
    if (select.value) setInvalid(select, false);
    sync(select);
  });

  /*
   * 色やタイプを切り替えると Dawn が情報列を描き直し、
   * ボタンが元の（押せる）状態に戻る。付け直すために描き直しを見張る。
   * 描き直しでボタンごと入れ替わっても、印の属性も一緒に消えるので付け直せる。
   */
  function watch() {
    var container = document.querySelector('.product__info-container');
    if (!container || !window.MutationObserver) return;

    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        syncAll();
      });
    }).observe(container, {
      childList: true,
      subtree: true,
      /* ボタンを丸ごと差し替えず disabled だけ外す実装もあるので、属性も見る */
      attributes: true,
      attributeFilter: ['disabled'],
    });
  }

  function init() {
    syncAll();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
